import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-site-information',
  standalone: true,
  imports: [CommonModule, FormsModule, MatInputModule, MatSelectModule, MatButtonModule,
     MatFormFieldModule, MatIconModule],
  templateUrl: './site-information.component.html',
  styleUrl: './site-information.component.scss'
})
export class SiteInformationComponent {
  grossSF: number = 0;
  grossAcres: number = 0;
  netSF: number = 0;
  netAcres: number = 0;
  excessSF: number = 0;
  excessAcres: number = 0;
  totalSF: number = 0;
  totalAcres: number = 0;

  utilities = [
    { label: 'Water' },
    { label: 'Sewer' },
    { label: 'Electricity' },
    { label: 'Gas' },
    { label: 'Telephone' }
  ];

  parkingRows: { type: string; spaces: number }[] = [];

  addRow() {
    this.parkingRows.push({ type: '', spaces: 0 });
  }

  removeRow(index: number) {
    this.parkingRows.splice(index, 1);
  }

  calculateLandAreas() {
    this.excessSF = this.grossSF - this.netSF;
    this.excessAcres = this.grossAcres - this.netAcres;
    this.totalSF = this.grossSF + this.netSF;
    this.totalAcres = this.grossAcres + this.netAcres;
  }
  
}
